import axios from 'axios';
import config from '../hoa-config';
import datastore from '../store/hoa-datastore';
import Axios from 'axios';
import { getChange, getType } from "../utility/change-log";
import { isViolationExtension, shouldApplyEffectiveDate } from '../utility/helper';
import { deepCompare } from '../utility/compare-item';
import { GenerateNewDocumentUrl } from "../utility/generate-new-document-url";
import { createExcelForMailList } from '../utility/create-excel-from-list';


axios.defaults.baseURL = config.baseUrl;
export default class dashboardServices {

	static async checkAccessRights() {
		return await axios.get(`/hasAccess`);
	}

	static async checkUserRole() {
		return await axios.get(`/checkUserRole`);
	}

	static async getUserInformation() {
		return await axios.get(`/getUserData`);
	}

	static async checkWhichOrgUser(userId: string) {
		return await axios.get(`/getOrganizationsByLoggedInUser?userId=${userId}`);
	}

	static async hoaEventsFileCopyAndStateUpdate(hoa: any) {
		if(hoa?.hoaEvents && hoa?.hoaEvents?.length > 0){
			for(const event of hoa.hoaEvents){
				if(event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.length >0){
					const existingFiles = event.newsLetterNotificationFiles.filter((item: any) => item.url)
					const toBeUpload = event.newsLetterNotificationFiles.filter((item: any) => item.isVerified)
					if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
						const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=hoaEventsAttachments`,toBeUpload);
						if(existingFiles && existingFiles.length>0 && data.length > 0){
							event.newsLetterNotificationFiles = [...existingFiles, ...data]
						} else if(!existingFiles.length && data.length > 0){
							event.newsLetterNotificationFiles = data;
						} else {
							event.newsLetterNotificationFiles = existingFiles;
						}
					}
				}
			}
		}
	}

	static async getMunicipalities(numberOfMuncipality: number, pageNo: number, options:any) {
		return await axios.get(`/getMunicipalities?&env=${datastore.env}&pageNo=${pageNo}&numberOfMuncipality=${numberOfMuncipality}`,{
			params: {
			  options: options
			}
		  });
	}

	static async addMunicipality(municipality: any, files: any) {
		const response =  await axios.post('/addMunicipality', municipality);
		if(files.tenantLeaseRegistrationFormUrl?.length > 0 || files.renewalFormUlr?.length > 0){
			const res = await this.updateMunicipality(response.data, files);
			return res;
		}
		return response;
	}

	static async addHoa(hoa: any, files?: any) {
		if (hoa?.hoaEvents) {
			await this.hoaEventsFileCopyAndStateUpdate(hoa);
		}
		const response =  await axios.post(`/addHoa?env=${datastore.env}`, hoa);
		// if(files.resolutionFormFile || files.renewalFormFile){
		// 	const res = await this.updateMunicipality(response.data, files);
		// 	return res;
		// }
		return response;
	}
	
	static async updateHoaFiles(files:any, hoaId:string) {
		const formData = new FormData();
		formData.append('hoaId', hoaId);
		Array.from(files).map((file:any)=>{
			formData.append('file',file);
		})
		return await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=recoupmentFormFiles`,formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}
		static async uploadHoaFiles(files:any,type:string,env:string, hoaId:string,) {
		const formData = new FormData();
			formData.append('hoaId', hoaId);
		if(Array.isArray(files)){
			Array.from(files).map((file:any)=>{
				formData.append('file',file);
			})
		}else{
			formData.append('file',files);
		}
		return await Axios.post(`/uploadHoaFiles?env=${env}&type=${type}`,formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	static async updateHoaCoreDocuments(hoa: any, selectedHoaDocuments: any) {
		const updatedDocuments = {
			...hoa?.documents
		}

		if(Object.keys(selectedHoaDocuments).length !== 0){
			for(let uploadItem in selectedHoaDocuments){
				let urls:any = [];
				if(selectedHoaDocuments[uploadItem]?.files && selectedHoaDocuments[uploadItem]?.files.length > 0){
					let filesData = selectedHoaDocuments[uploadItem]?.files;
					let nextVersion: any = -1;
					if(hoa?.documents && hoa?.documents[uploadItem]?.files && hoa?.documents[uploadItem]?.files.length > 0){
						for (var i = 0; i < hoa?.documents[uploadItem]?.files.length; i++) {
							if (hoa?.documents[uploadItem]?.files[i].version > nextVersion) {
								nextVersion = hoa?.documents[uploadItem]?.files[i].version;
							}
						}
					}else{
						nextVersion = 0;
					}
					const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&version=${nextVersion}&folder=${`documents/${uploadItem.replace(/[ /]/g, "-")}`}`,filesData);
					urls = data;
				}
				let updatedFiles = hoa?.documents[uploadItem]?.files ? hoa?.documents[uploadItem]?.files : [];
				let updatedHyperlink = hoa?.documents[uploadItem]?.hyperLink ? hoa?.documents[uploadItem]?.hyperLink : [];
				urls.length > 0 && urls.map((item: any, index: number) => {
					updatedFiles.push({
						name: item.fileName,
						url: item.url,
						sourceId: item.sourceId,
						sourceIdType: item.sourceIdType,
						uploadedTime: new Date().toISOString(),
						// version: hoa?.documents[uploadItem]?.files ? nextVersion : 0,
						versionName: 'new'
					});
				})
				const value = {
					files: updatedFiles,
					uploadedBy: datastore.ownerInformation.name,
					lastUpdated: new Date(),
					hyperLink: updatedHyperlink.concat(selectedHoaDocuments[uploadItem]?.hyperLink),
					amendmentDate: selectedHoaDocuments[uploadItem]?.AmendmentDate,
				};
		
				updatedDocuments[uploadItem] = value;
			}
		}

		return updatedDocuments;
	}

	static async updateHoaOnboardingData(hoaId:string, onboardingDataState: any, onboardingDocuments:any) {
		for (const key of Object.keys(onboardingDocuments)) {
			const onboardingFormData = new FormData();
			onboardingFormData.append("hoaId", hoaId);
			let newFileAdded = false;

			// add new files in formdata
			for (const file of onboardingDocuments[key]) {
				if (file?.name) {
					newFileAdded = true;
					onboardingFormData.append('file', file);
				}
			}

			// remove new files from onboarding state
			onboardingDocuments[key] = onboardingDocuments[key].filter((file:any) => file.fileName);

			if (newFileAdded) {
				const res = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=onboardingData`, onboardingFormData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});

				onboardingDocuments[key] = [...onboardingDocuments[key], ...res.data];
				onboardingFormData.delete('file');
			}
		}

		if (Array.isArray(onboardingDocuments["clientDirectory"]) && onboardingDocuments["clientDirectory"].length > 0) {
			onboardingDataState["clientDirectory"].data = {
				...onboardingDataState["clientDirectory"].data,
				documents: onboardingDocuments["clientDirectory"]
			}
		}

		if (Array.isArray(onboardingDocuments["portalSearch"]) && onboardingDocuments["portalSearch"].length > 0) {
			onboardingDataState["portalSearch"].data = {
				...onboardingDataState["portalSearch"].data,
				documents: onboardingDocuments["portalSearch"]
			}
		}

		if (Array.isArray(onboardingDocuments["emailHoa"]) && onboardingDocuments["emailHoa"].length > 0) {
			onboardingDataState["emailHoa"].data = {
				...onboardingDataState["emailHoa"].data,
				documents: onboardingDocuments["emailHoa"]
			}
		}

		if (Array.isArray(onboardingDocuments["emailHoaScreenshot"]) && onboardingDocuments["emailHoaScreenshot"].length > 0) {
			onboardingDataState["emailHoa"].data = {
				...onboardingDataState["emailHoa"].data,
				screenshot: onboardingDocuments["emailHoaScreenshot"]
			}
		}

		if (Array.isArray(onboardingDocuments["callHoa"]) && onboardingDocuments["callHoa"].length > 0) {
			onboardingDataState["callHoa"].data = {
				...onboardingDataState["callHoa"].data,
				documents: onboardingDocuments["callHoa"]
			}
		}

		if (Array.isArray(onboardingDocuments["callHoaScreenshot"]) && onboardingDocuments["callHoaScreenshot"].length > 0) {
			onboardingDataState["callHoa"].data = {
				...onboardingDataState["callHoa"].data,
				screenshot: onboardingDocuments["callHoaScreenshot"]
			}
		}

		return onboardingDataState;
	}

	static async updateDocumentFiles(hoa: any, selectedHoaDocuments: any, structureBuildingFiles: any, sourceDocuments:any, updatedOnBodingState: any) {
		const formData = new FormData();
		formData.append('hoaId', hoa.objectId);

		if(Object.keys(selectedHoaDocuments).length !== 0){
			const updatedHoaDocuments = await this.updateHoaCoreDocuments(hoa, selectedHoaDocuments);
			hoa.documents = updatedHoaDocuments;
		}

		if (updatedOnBodingState) {
			hoa.onboardingData = updatedOnBodingState;
		}
		if(structureBuildingFiles.structureChangeFiles.length){
			const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=structureChangeFiles`,structureBuildingFiles.structureChangeFiles);

			if(hoa.violationRegulations?.structure?.structureChangeFiles && hoa.violationRegulations?.structure?.structureChangeFiles.length>0 && data && data.length > 0){
				hoa.violationRegulations.structure.structureChangeFiles = hoa.violationRegulations?.structure?.structureChangeFiles.concat(data)
			} else {
				hoa.violationRegulations.structure.structureChangeFiles = data;
			}
		}

		if(structureBuildingFiles.architecturalFiles.length){
			Array.from(structureBuildingFiles.architecturalFiles).map((file:any)=>{
				formData.append('file',file);
			})
			const res = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=architecturalFiles`,formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			if(hoa.violationRegulations?.structure?.architecturalFiles && hoa?.violationRegulations?.structure?.architecturalFiles.length>0 && res.data && res.data.length > 0){
				hoa.violationRegulations.structure.architecturalFiles = hoa?.violationRegulations?.structure?.architecturalFiles.concat(res.data)
			} else {
				hoa.violationRegulations.structure.architecturalFiles = res.data;
			}
			formData.delete('file');
		}
		if(sourceDocuments?.length){
			const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=sourceDocuments`,sourceDocuments);

			if(hoa.procedures?.sourceDocuments && hoa?.procedures?.sourceDocuments.length>0 && data.length > 0){
				hoa.procedures.sourceDocuments = hoa?.procedures?.sourceDocuments.concat(data)
			} else {
				hoa.procedures.sourceDocuments = data;
			}
		}
		if(hoa?.gateAccessFormFiles && hoa.gateAccessFormFiles.length > 0) {
			const existingFiles = hoa.gateAccessFormFiles.filter((item: any) => item.url)
			const toBeUpload = hoa.gateAccessFormFiles.filter((item: any) => item.isVerified)
			if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
				const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=gateAccessFormFiles`,toBeUpload);
				if(existingFiles && existingFiles.length>0 && data.length > 0){
					hoa.gateAccessFormFiles = [...existingFiles, ...data]
				} else if(!existingFiles.length && data.length > 0){
					hoa.gateAccessFormFiles = data;
				} else {
					hoa.gateAccessFormFiles = existingFiles;
				}
			}
		}

		if(hoa?.newAvailableAmenities && hoa?.newAvailableAmenities?.length >0){
			for(const availableAmenity of hoa.newAvailableAmenities){
				if(availableAmenity?.locations && availableAmenity?.locations?.length >0){

					const amenityPhotos = new FormData();
					amenityPhotos.append('hoaId', hoa.objectId);

					for(const location of availableAmenity.locations){
						if(location.additionalAmenitiesDocument && location.additionalAmenitiesDocument.length >0){
							const existingFiles = location.additionalAmenitiesDocument.filter((item: any) => item.url)
							const toBeUpload = location.additionalAmenitiesDocument.filter((item: any) => item.isVerified)
							if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
								const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=additionalAmenitiesDocument`,toBeUpload);
								if(existingFiles && existingFiles.length>0 && data.length > 0){
									location.additionalAmenitiesDocument = [...existingFiles, ...data]
								} else if(!existingFiles.length && data.length > 0){
									location.additionalAmenitiesDocument = data;
								} else {
									location.additionalAmenitiesDocument = existingFiles;
								}
							}
						}
						
						if(location.rulesAndRegulationDocuments && location.rulesAndRegulationDocuments.length >0){
							const existingFiles = location.rulesAndRegulationDocuments.filter((item: any) => item.url)
							const toBeUpload = location.rulesAndRegulationDocuments.filter((item: any) => item.isVerified)
							if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
								const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=rulesAndRegulationDocuments`,toBeUpload);
								if(existingFiles && existingFiles.length>0 && data.length > 0){
									location.rulesAndRegulationDocuments = [...existingFiles, ...data]
								} else if(!existingFiles.length && data.length > 0){
									location.rulesAndRegulationDocuments = data;
								} else {
									location.rulesAndRegulationDocuments = existingFiles;
								}
							}
						}
						if(location.amenityPhotos && location.amenityPhotos.length >0){
                           location.amenityPhotos.map(async (file: any, index: string) => {
								if(file.name){
									amenityPhotos.append('file',file);
								}
							})
						}
					}
					let res3
					if(amenityPhotos.has("file")){	
						res3 = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=amenityPhotos`,amenityPhotos, {
							headers: {
								'Content-Type': 'multipart/form-data'
							}
						});
					}

					for(const location of availableAmenity.locations){
						   if(location.amenityPhotos && location.amenityPhotos.length >0){

							   for(let i = 0; i< location.amenityPhotos.length; i++){
								if(location.amenityPhotos[i].name){
									res3.data && res3.data.map((item: any) => {
										if(item.fileName == location.amenityPhotos[i].name){
											location.amenityPhotos[i] = item;
										}
									})
								}
							   }
						   }
					}
				}
			}
		}

		if(hoa?.accessInformation && hoa?.accessInformation?.length > 0){
			for(const accessInformation of hoa.accessInformation){
				if(accessInformation.accessForm && accessInformation.accessForm.length >0){
					const existingFiles = accessInformation.accessForm.filter((item: any) => item.url)
					const toBeUpload = accessInformation.accessForm.filter((item: any) => item.isVerified)

					if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
						const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=accessForm`,toBeUpload);
						if(existingFiles && existingFiles.length>0 && data.length > 0){
							accessInformation.accessForm = [...existingFiles, ...data]
						} else if(!existingFiles.length && data.length > 0){
							accessInformation.accessForm = data;
						} else {
							accessInformation.accessForm = existingFiles;
						}
					}
				}
			}
		}

		if(hoa?.amenityEvents && hoa?.amenityEvents?.length > 0){
			for(const event of hoa.amenityEvents){
				if(event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.length >0){
					const existingFiles = event.newsLetterNotificationFiles.filter((item: any) => item.url)
					const toBeUpload = event.newsLetterNotificationFiles.filter((item: any) => item.isVerified)

					if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
						const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=newsLetterNotificationFiles`,toBeUpload);
						if(existingFiles && existingFiles.length>0 && data.length > 0){
							event.newsLetterNotificationFiles = [...existingFiles, ...data]
						} else if(!existingFiles.length && data.length > 0){
							event.newsLetterNotificationFiles = data;
						} else {
							event.newsLetterNotificationFiles = existingFiles;
						}
					}
				}
			}
		}
		// Hoa events file upload and state update
		if (hoa?.hoaEvents) {
			await this.hoaEventsFileCopyAndStateUpdate(hoa);
		}
		return hoa;
	}

	static async updateHoa(hoa: any, selectedHoaDocuments: any, structureBuildingFiles: any, sourceDocuments:any, updatedOnBodingState: any) {
		// const formData = new FormData();
		// formData.append('hoaId', hoa.objectId);

		// if(Object.keys(selectedHoaDocuments).length !== 0){
		// 	const updatedHoaDocuments = await this.updateHoaCoreDocuments(hoa, selectedHoaDocuments);
		// 	hoa.documents = updatedHoaDocuments;
		// }

		// if (updatedOnBodingState) {
		// 	hoa.onboardingData = updatedOnBodingState;
		// }
		// if(structureBuildingFiles.structureChangeFiles.length){
		// 	const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=structureChangeFiles`,structureBuildingFiles.structureChangeFiles);

		// 	if(hoa.violationRegulations?.structure?.structureChangeFiles && hoa.violationRegulations?.structure?.structureChangeFiles.length>0 && data && data.length > 0){
		// 		hoa.violationRegulations.structure.structureChangeFiles = hoa.violationRegulations?.structure?.structureChangeFiles.concat(data)
		// 	} else {
		// 		hoa.violationRegulations.structure.structureChangeFiles = data;
		// 	}
		// }

		// if(structureBuildingFiles.architecturalFiles.length){
		// 	Array.from(structureBuildingFiles.architecturalFiles).map((file:any)=>{
		// 		formData.append('file',file);
		// 	})
		// 	const res = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=architecturalFiles`,formData, {
		// 		headers: {
		// 			'Content-Type': 'multipart/form-data'
		// 		}
		// 	});
		// 	if(hoa.violationRegulations?.structure?.architecturalFiles && hoa?.violationRegulations?.structure?.architecturalFiles.length>0 && res.data && res.data.length > 0){
		// 		hoa.violationRegulations.structure.architecturalFiles = hoa?.violationRegulations?.structure?.architecturalFiles.concat(res.data)
		// 	} else {
		// 		hoa.violationRegulations.structure.architecturalFiles = res.data;
		// 	}
		// 	formData.delete('file');
		// }
		// if(sourceDocuments?.length){
		// 	const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=sourceDocuments`,sourceDocuments);

		// 	if(hoa.procedures?.sourceDocuments && hoa?.procedures?.sourceDocuments.length>0 && data.length > 0){
		// 		hoa.procedures.sourceDocuments = hoa?.procedures?.sourceDocuments.concat(data)
		// 	} else {
		// 		hoa.procedures.sourceDocuments = data;
		// 	}
		// }
		// if(hoa?.gateAccessFormFiles && hoa.gateAccessFormFiles.length > 0) {
		// 	const existingFiles = hoa.gateAccessFormFiles.filter((item: any) => item.url)
		// 	const toBeUpload = hoa.gateAccessFormFiles.filter((item: any) => item.isVerified)
		// 	if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
		// 		const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=gateAccessFormFiles`,toBeUpload);
		// 		if(existingFiles && existingFiles.length>0 && data.length > 0){
		// 			hoa.gateAccessFormFiles = [...existingFiles, ...data]
		// 		} else if(!existingFiles.length && data.length > 0){
		// 			hoa.gateAccessFormFiles = data;
		// 		} else {
		// 			hoa.gateAccessFormFiles = existingFiles;
		// 		}
		// 	}
		// }

		// if(hoa?.newAvailableAmenities && hoa?.newAvailableAmenities?.length >0){
		// 	for(const availableAmenity of hoa.newAvailableAmenities){
		// 		if(availableAmenity?.locations && availableAmenity?.locations?.length >0){

		// 			const amenityPhotos = new FormData();
		// 			amenityPhotos.append('hoaId', hoa.objectId);

		// 			for(const location of availableAmenity.locations){
		// 				if(location.additionalAmenitiesDocument && location.additionalAmenitiesDocument.length >0){
		// 					const existingFiles = location.additionalAmenitiesDocument.filter((item: any) => item.url)
		// 					const toBeUpload = location.additionalAmenitiesDocument.filter((item: any) => item.isVerified)
		// 					if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
		// 						const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=additionalAmenitiesDocument`,toBeUpload);
		// 						if(existingFiles && existingFiles.length>0 && data.length > 0){
		// 							location.additionalAmenitiesDocument = [...existingFiles, ...data]
		// 						} else if(!existingFiles.length && data.length > 0){
		// 							location.additionalAmenitiesDocument = data;
		// 						} else {
		// 							location.additionalAmenitiesDocument = existingFiles;
		// 						}
		// 					}
		// 				}
						
		// 				if(location.rulesAndRegulationDocuments && location.rulesAndRegulationDocuments.length >0){
		// 					const existingFiles = location.rulesAndRegulationDocuments.filter((item: any) => item.url)
		// 					const toBeUpload = location.rulesAndRegulationDocuments.filter((item: any) => item.isVerified)
		// 					if (Array.isArray(toBeUpload) && toBeUpload.length > 0) {
		// 						const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=rulesAndRegulationDocuments`,toBeUpload);
		// 						if(existingFiles && existingFiles.length>0 && data.length > 0){
		// 							location.rulesAndRegulationDocuments = [...existingFiles, ...data]
		// 						} else if(!existingFiles.length && data.length > 0){
		// 							location.rulesAndRegulationDocuments = data;
		// 						} else {
		// 							location.rulesAndRegulationDocuments = existingFiles;
		// 						}
		// 					}
		// 				}
		// 				if(location.amenityPhotos && location.amenityPhotos.length >0){
        //                    location.amenityPhotos.map(async (file: any, index: string) => {
		// 						if(file.name){
		// 							amenityPhotos.append('file',file);
		// 						}
		// 					})
		// 				}
		// 			}
		// 			let res3
		// 			if(amenityPhotos.has("file")){	
		// 				res3 = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=amenityPhotos`,amenityPhotos, {
		// 					headers: {
		// 						'Content-Type': 'multipart/form-data'
		// 					}
		// 				});
		// 			}

		// 			for(const location of availableAmenity.locations){
		// 				   if(location.amenityPhotos && location.amenityPhotos.length >0){

		// 					   for(let i = 0; i< location.amenityPhotos.length; i++){
		// 						if(location.amenityPhotos[i].name){
		// 							res3.data && res3.data.map((item: any) => {
		// 								if(item.fileName == location.amenityPhotos[i].name){
		// 									location.amenityPhotos[i] = item;
		// 								}
		// 							})
		// 						}
		// 					   }
		// 				   }
		// 			}
		// 		}
		// 	}
		// }
		// if(hoa?.accessInformation && hoa?.accessInformation?.length >0){
		// 	const accessFormData = new FormData();
		// 	accessFormData.append('hoaId', hoa.objectId);

		// 	const RulesAndRegulationDocumentsaccessFormData = new FormData();
		// 	RulesAndRegulationDocumentsaccessFormData.append('hoaId', hoa.objectId);

		// 	for(const accessInformation of hoa.accessInformation){
		// 		if(accessInformation.accessForm && accessInformation.accessForm.length >0){
        //           accessInformation.accessForm.map(async (file: any, index: string) => {
		// 			if(file.name){
		// 				accessFormData.append('file',file);
		// 			}
		// 		  })
		// 		}
		// 		if(accessInformation.accessInformationRulesAndRegulationDocuments && accessInformation.accessInformationRulesAndRegulationDocuments.length >0){
		// 			 accessInformation.accessInformationRulesAndRegulationDocuments.map(async (file: any, index: string) => {
		// 			if(file.name){
		// 				RulesAndRegulationDocumentsaccessFormData.append('file',file);
		// 			}
		// 		  })
		// 		}
		//     }

		// 	let res1
		// 	if(accessFormData.has("file")){	
		// 	     res1 = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=accessForm`,accessFormData, {
		// 			headers: {
		// 				'Content-Type': 'multipart/form-data'
		// 			}
		// 		});
		// 	}
		// 	let res2
		// 	if(RulesAndRegulationDocumentsaccessFormData.has("file")){	
		// 	     res2 = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=accessInformationRulesAndRegulationDocuments`,RulesAndRegulationDocumentsaccessFormData, {
		// 			headers: {
		// 				'Content-Type': 'multipart/form-data'
		// 			}
		// 		});
		// 	}

		// 	for(const accessInformation of hoa.accessInformation){
		// 		if(accessInformation.accessForm && accessInformation.accessForm.length >0){
		// 			for(let i = 0; i< accessInformation.accessForm.length; i++){
		// 			if(accessInformation.accessForm[i].name){
		// 				res1.data && res1.data.map((item: any) => {
		// 					if(item.fileName == accessInformation.accessForm[i].name){
		// 						accessInformation.accessForm[i] = item;
		// 					}
		// 				 })
		// 			   }
		// 			}
		// 		}
		// 		if(accessInformation.accessInformationRulesAndRegulationDocuments && accessInformation.accessInformationRulesAndRegulationDocuments.length >0){

		// 			for(let i = 0; i< accessInformation.accessInformationRulesAndRegulationDocuments.length; i++){
		// 			if(accessInformation.accessInformationRulesAndRegulationDocuments[i].name){
		// 				res2.data && res2.data.map((item: any) => {
		// 					if(item.fileName == accessInformation.accessInformationRulesAndRegulationDocuments[i].name){
		// 						accessInformation.accessInformationRulesAndRegulationDocuments[i] = item;
		// 					}
		// 				 })
		// 			   }
		// 			}
		// 		}
		//     }
		// }
		// if(hoa?.amenities?.amenityEvents && hoa.amenities?.amenityEvents?.length > 0){
		// 	for(const event of hoa.amenities?.amenityEvents){
		// 		event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.map(async (file: any, index: string) => {
		// 			if(file.name){
		// 				formData.append('file',file);
		// 			}
		// 		})
		// 	}
		// 	let res
		// 	if(formData.has("file")){	
		// 	     res = await Axios.post(`/uploadHoaFiles?env=${datastore.env}&type=newsLetterNotificationFiles`,formData, {
		// 			headers: {
		// 				'Content-Type': 'multipart/form-data'
		// 			}
		// 		});
		// 	}
		// 	for(const event of hoa.amenities?.amenityEvents){
		// 		if(event?.newsLetterNotificationFiles){
		// 			for(let i = 0; i< event?.newsLetterNotificationFiles.length; i++){
		// 				if(event.newsLetterNotificationFiles[i]?.name){
		// 					res.data && res.data.map((item: any) => {
		// 						if(item.fileName == event.newsLetterNotificationFiles[i].name){
		// 							event.newsLetterNotificationFiles[i] = item;
		// 						}
		// 					})
		// 				}
		// 			}
		// 		}
		// 	}		
		// 	formData.delete('file');
		// }
		// if(hoa?.amenityEvents && hoa?.amenityEvents?.length > 0){
		// 	for(const event of hoa.amenityEvents){
		// 		if(event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.length >0){
		// 			const existingFiles = event.newsLetterNotificationFiles.filter((item: any) => item.url)
		// 			const toBeUpload = event.newsLetterNotificationFiles.filter((item: any) => item.isVerified)

		// 			const { data } = await axios.post(`/copyFileAttachmentToHoaModule?env=${datastore.env}&objectId=${hoa.objectId}&folder=newsLetterNotificationFiles`,toBeUpload);
		// 			if(existingFiles && existingFiles.length>0 && data.length > 0){
		// 				event.newsLetterNotificationFiles = [...existingFiles, ...data]
		// 			} else if(!existingFiles.length && data.length > 0){
		// 				event.newsLetterNotificationFiles = data;
		// 			} else {
		// 				event.newsLetterNotificationFiles = existingFiles;
		// 			}
		// 		}
		// 	}
		// }
		// // Hoa events file upload and state update
		// if (hoa?.hoaEvents) {
		// 	await this.hoaEventsFileCopyAndStateUpdate(hoa);
		// }
		const response =  await axios.post('/updateHoa?env='+datastore.env, hoa);
		return response;
	}

	static async updateMunicipality(municipality: any, files: any) {
		const formData = new FormData();
		formData.append('municipalityId', municipality.objectId);
		if(files.tenantLeaseRegistrationFormUrl.length){
			Array.from(files.tenantLeaseRegistrationFormUrl).map((file:any)=>{
				formData.append('file',file);
			})
			const tenantLeaseRegistrationForm = await Axios.post(`/uploadForm?env=${datastore.env}&type=resolutionForm`,formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			if(municipality.tenantLeaseRegistrationFormUrl && municipality.tenantLeaseRegistrationFormUrl.length>0 && tenantLeaseRegistrationForm.data && tenantLeaseRegistrationForm.data.length > 0){
				municipality.tenantLeaseRegistrationFormUrl = municipality.tenantLeaseRegistrationFormUrl.concat(tenantLeaseRegistrationForm.data)
			} else {
				municipality.tenantLeaseRegistrationFormUrl = tenantLeaseRegistrationForm.data;
			}
		}
		formData.delete('file');
		if(files.countyOrMunicipalityRenewalForm.length){
			Array.from(files.countyOrMunicipalityRenewalForm).map((file:any)=>{
				formData.append('file',file);
			})
			const renewalForm = await Axios.post(`/uploadForm?env=${datastore.env}&type=renewalForm`,formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			if(municipality.countyOrMunicipalityRenewalForm && municipality.countyOrMunicipalityRenewalForm.length>0 && renewalForm.data && renewalForm.data.length > 0){
				municipality.countyOrMunicipalityRenewalForm = municipality.countyOrMunicipalityRenewalForm.concat(renewalForm.data)
			} else {
				municipality.countyOrMunicipalityRenewalForm = renewalForm.data;
			}
		}
		formData.delete('file');

		const response =  await axios.post('/updateMunicipality?env='+datastore.env, municipality);

		//response.data.formUrl = uploadDoc.data;

		return response;
	}

	static async retryWebhook(objectId:string, appLogId:string, triggerNotificationId: string) {
		const appLogResult = await axios.get(`/getCreatedLogById?env=${datastore.env}&appLogId=${appLogId}`);

		if (appLogResult.status == 200 && appLogResult.data) {
			const message = appLogResult.data;

			const notificationResult = await axios.get(`/getTriggerNotificationById?env=${datastore.env}&triggerNotificationId=${triggerNotificationId}`)

			if (notificationResult.status == 200 && notificationResult.data) {
				const events = message.events[0];
				let event:string;

				if (events.includes('Update HOA')) {
					event = 'Update HOA'
				} else if (events.includes('Update Property') || events.includes('Email assigned to property') || events.includes('Mail assigned to property') || isViolationExtension(events) || event.includes('Mail Marked as Non-Assignable') || event.includes('Email Marked as Non-Assignable')) {
					event = 'Update Property'
				} else if (events.includes('Update Municipality')) {
					event = 'Update Municipality'
				}

				// let type = message.type.toLowerCase() === 'hoa' ? 'hoas' : message.type.toLowerCase() === 'municipality' ? 'municipalities' : 'properties';
				const type = getType(message.type.toLowerCase())

				let changes:any = {};

				try {
					changes = getChange(message);
				} catch(ex) { }

				const payload:any = {
					"eventName": event,
					"tagType": message.type,
					"tagTypeId": message.tagTypeId,
					"billItem": !message.billItem ? 'Not Billable' : message.billItem,
					"fullDataPoint": `https://www.insidemaps.com/app/hoa-dashboard/?env=production&menu=${type}&id=${message.tagTypeId}`,
					"events": message.events,
					"updatedAt": message?.updatedAt
				}

				if (message.effectiveDate && shouldApplyEffectiveDate(message.effectiveDate)) {
					payload.updateType = "Scheduled",
					payload.effectiveDate = message.effectiveDate.format('MM/DD/YYYY');
				}
				else {
					payload.updateType = "Immediate"
				}
				
				let url: any = notificationResult.data.url;

				const requestBody = {
					payload,
					url
				};

				const clientResponse = await axios.post('/createTriggerNotification?env=' + datastore.env, requestBody);

				const data:any = {
					objectId: objectId,
					appLogsId: appLogId,
					triggerNotificationId: triggerNotificationId,
					changes: changes
				}

				if (!clientResponse || clientResponse.status != 200) {
					data['status'] = false;
				}
				else {
					data['status'] = true;
					data['log'] = JSON.stringify(clientResponse.data ? clientResponse.data : {});
				}

				return await axios.post('/createTriggerNotificationLog', data);
			}
		}
	}

	static async triggerWebhookAndCreateNotification(logData:any){
		if (logData?.organization?.objectId != 'XhZBTB9mDM' && logData?.organization?.objectId != 'cSzprl5nZN') {
			return;
		}

		if (logData.events && logData.events.length) {
			const event = logData.events[0]
			let events = event;
			if (event.includes('Update HOA')) {
				events = 'Update HOA'
			} else if (event.includes('Update Property') || event.includes('Email assigned to property') || event.includes('Mail assigned to property') || isViolationExtension(event) || event.includes('Mail Marked as Non-Assignable') || event.includes('Email Marked as Non-Assignable')) {
				events = 'Update Property'
			} else if (event.includes('Update Municipality')) {
				events = 'Update Municipality'
			}
			const orgs = ['XhZBTB9mDM']
			const notifications = await axios.get(`/getTriggerUrl?env=${datastore.env}&type=${logData.type}&event=${events}`, {
				params: {
					orgs: orgs
				}
			});

			for (let notification of notifications.data) {
				//let type = logData.type.toLowerCase() === 'hoa' ? 'hoas' : logData.type.toLowerCase() === 'municipality' ? 'municipalities' : 'properties';
				const type = getType(logData.type.toLowerCase())
				let changes:any = {};

				try {
					changes = getChange(logData);
				} catch(ex) { }

				const payload:any = {
					"eventName": events,
					"tagType": logData.type,
					"tagTypeId": logData.tagTypeId,
					"billItem": !logData.billItem ? 'Not Billable' : logData.billItem,
					"fullDataPoint": `https://www.insidemaps.com/app/hoa-dashboard/?env=production&menu=${type}&id=${logData.tagTypeId}`,
					"events": logData.events,
					"updatedAt": logData?.updatedAt
				}

				if (logData.effectiveDate && logData.effectiveDate?.iso && shouldApplyEffectiveDate(logData.effectiveDate?.iso)) {
					payload.updateType = "Scheduled",
					payload.effectiveDate = logData.effectiveDate.format('MM/DD/YYYY');
				}
				else {
					payload.updateType = "Immediate"
				}
				
				let url: any = notification.url;
				const requestBody = {
					payload,
					url
				};

				const clientResponse = await axios.post('/createTriggerNotification?env=' + datastore.env, requestBody);
				
				const data:any = {
					appLogsId: logData?.objectId,
					triggerNotificationId: notification.objectId,
					changes: changes
				}

				if (!clientResponse || clientResponse.status != 200) {
					data['status'] = false;
				}
				else {
					data['status'] = true;
					data['log'] = JSON.stringify(clientResponse.data ? clientResponse.data : {});
				}

				await axios.post('/createTriggerNotificationLog', data);
			}
		}
	}

	static async createLogs(message: any) {
		const logs:any = await axios.post('/createLogs?env=' + datastore.env, message);

		logs.data.forEach(async(log:any)=>{
			await this.triggerWebhookAndCreateNotification(log);
		})
		return logs
	}

	static async updateSingleLog(message: any) {
		return await axios.post('/updateSingleLog?env='+datastore.env, message);
	}

	static async updateLogs(message: any) {
		return await axios.post('/updateLogs?env='+datastore.env, message);
	}

	static async updateHoaBillItem(message:any) {
		return await axios.post('/updateHoaBillItem?env='+datastore.env, message);
	}

	static async createMultipleLogs(messages:Array<any>) {
		const logs:any = await axios.post('/createMultipleLogs?env='+datastore.env, messages);
		logs.data.forEach(async(log:any)=>{
			await this.triggerWebhookAndCreateNotification(log);
		})
		return logs
	}

	static async deleteMultipleLogs(lgoIdsList:Array<any>) {
		let logIds: string;

		try {
			logIds = lgoIdsList.join(',');
		}
		catch(ex) {}

		const message = {
			logIds
		}

		return await axios.post('/deleteMultipleLogs?env=' + datastore.env, message);
	}

	static async getCreatedLogs(objectId:string, numberOfProjects?: number, page?: number, options?: any) {
		return await axios.get(`/getCreateLogs?env=${datastore.env}&id=${objectId}&numberOfProjects=${numberOfProjects}&page=${page}`, {
			params: {
				options: options
			}
		});
	}

	static async linkedEntryIdVerify(objectId:string, linkedEntryId?: string) {
		return await axios.get(`/verifyLinkedEntryId?env=${datastore.env}&id=${objectId}&linkedEntryId=${linkedEntryId}`);
	}

	static async updateMailOrEmailAssignedLog(propertyId: string, type: string, objectId: string, billAmount: number, billItem: string) {
		return await axios.post(`/updateMailOrEmailAssignedLog?env=${datastore.env}&propertyId=${propertyId}&type=${type}&objectId=${objectId}&billAmount=${billAmount}&billItem=${billItem}`)
	}

	static async getCreatedLog(propertyId:string, mailId: string) {
		return await axios.get(`/getCreateLog?env=${datastore.env}&propertyId=${propertyId}&mailId=${mailId}`);
	}

	static async removeMuncipality(objectId:string) {
		return await axios.post(`/removeMuncipality?env=${datastore.env}&id=${objectId}`);
	}

	static async getBillableItems(type: string) {
		return await axios.get(`/getBillableItems?env=${datastore.env}&type=${type}`);
	}

	static async getFutureEffectiveDateLog(tagTypeId:string) {
		return await axios.get(`/getFutureEffectiveDateLog?env=${datastore.env}&tagTypeId=${tagTypeId}`);
	}

	/* <---- Hoa ----> */

	static async getHoas(numberOfHoas: number, pageNo: number, options:any, selectedOrganization?: any) {
		return await axios.get(`/getHos?&env=${datastore.env}&pageNo=${pageNo}&numberOfHoas=${numberOfHoas}&selectedOrganization=${selectedOrganization}`,{
			params: {
			  options: options
			}
		  });
	}

	static async getHoasByName(searchString: string) {
		return await axios.get(`/getHoasByName?&env=${datastore.env}&searchString=${searchString}`);
	}

	static async removeHOA(objectId:string) {
		return await axios.post(`/removeHOA?env=${datastore.env}&id=${objectId}`);
	}

	static async updateHoaDocuments(documents:any,objectId:string) {
		return await axios.post(`/updateHoaDocuments?env=${datastore.env}&objectId=${objectId}`,documents);
	}

	static async uploadDocuments(files:any,objectId:string,folder:string,version:number) {
		const formData = new FormData();
		files.map((file:any)=>formData.append('file',file))
		formData.append('folder', folder);
		return await axios.post(`/uploadDocuments?env=${datastore.env}&objectId=${objectId}&version=${version}`,formData,{
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	static async deleteMunicipalityDocuments(documents: any, objectId:string, folder:string){
		return await axios.post(`/deleteMunicipalityDocuments?env=${datastore.env}&objectId=${objectId}&folder=${folder}`, documents);
	}
	
	static async deletePhotos(documents: any, objectId:string, folder:string){
		return await axios.post(`/deletePhotos?env=${datastore.env}&objectId=${objectId}&folder=${folder}`, documents);
	}
	
	static async deleteDocuments(documents: any, objectId:string, folder:string){
		return await axios.post(`/deleteDocuments?env=${datastore.env}&objectId=${objectId}&folder=${folder}`, documents);
	}

	static async getSignedUrl(path:string, bucketName?:string, isEmail: boolean = false, isTextFile: boolean = false) {
		let requestBody:any = {
			path,
			isEmail,
			isTextFile
		}

		if(bucketName) {
			requestBody = {
				...requestBody,
				bucketName
			}
		}
		
		return await axios.post(`/getSignedUrl?env=${datastore.env}`, requestBody);
	}

	// property

	static async getProperties(numberOfProperty: number, pageNo: number, options:any, selectedOrganization?: any, signal?:any) {
		return await axios.get(`/getPropeties?&env=${datastore.env}&pageNo=${pageNo}&numberOfProperties=${numberOfProperty}&selectedOrganization=${selectedOrganization}`,{
			signal: signal && signal,
			params: {
				options: options
			}
		});
	}

	static async getHoaById(id:string, selectedOrganization: string, excludeDeletedHoa: boolean = false) {
		const hoa:any = await axios.get(`/getHoaById?env=${datastore.env}&objectId=${id}&selectedOrganization=${selectedOrganization}&excludeDeletedHoa=${excludeDeletedHoa}`);

		if (Array.isArray(hoa?.data?.newAvailableAmenities)) {
			for (const amenity of hoa.data.newAvailableAmenities) {
				if (Array.isArray(amenity?.locations)) {
					for (const location of amenity.locations) {
						if (Array.isArray(location?.amenityPhotos)) {
							for (const photo of location.amenityPhotos) {
								if (photo?.url) {
									const newUrl = await GenerateNewDocumentUrl.getNewUrl(photo?.url, 'hoa', 'amenityPhotos');
									photo.url = newUrl;
								}
							}
						}
					}
				}
			}
		} 

		return hoa;
	}

	static async getMunicipalityById(id:string) {
		return await axios.get(`/getMunicipalityById?env=${datastore.env}&objectId=${id}`);
	}

	static async getPropertyById(id:string) {
		return await axios.get(`/getPropertyById?env=${datastore.env}&objectId=${id}`);
	}

	static async createNewProperty(property:any,userId:string, files: any) {
		const response = await axios.post(`/createNewProperty?env=${datastore.env}&userId=${userId}`,property);
		
		if(files.propertyNoticeFiles?.length>0){
			const res = await this.updateProperty(response.data, '', files, '')
			return res;
		}
		return response;
	}

	static async updateProperty(property:any,preHoaId:string, files: any, preOrgId:string) {
		const formData = new FormData();
		formData.append('propertyId', property.objectId);
		if(files.propertyNoticeFiles.length){
			Array.from(files.propertyNoticeFiles).map((file:any)=>{
				formData.append('file',file);
			})
			const propertyNoticeFilesUrl = await Axios.post(`/uploadPropertyFiles?env=${datastore.env}&type=propertyNoticeFiles`,formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			if(property.propertyNoticeFiles && property.propertyNoticeFiles.length>0 && propertyNoticeFilesUrl.data && propertyNoticeFilesUrl.data.length > 0){
				property.propertyNoticeFiles = property.propertyNoticeFiles.concat(propertyNoticeFilesUrl.data)
			} else {
				property.propertyNoticeFiles = propertyNoticeFilesUrl.data;
			}
		}
		formData.delete('file');
		if(files.hearingNoticeFiles.length){
			Array.from(files.hearingNoticeFiles).map((file:any)=>{
				formData.append('file',file);
			})
			const hearingNoticeFilesUrl = await Axios.post(`/uploadPropertyFiles?env=${datastore.env}&type=hearingNoticeFiles`,formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			if(property.hearingNoticeFiles && property.hearingNoticeFiles.length>0 && hearingNoticeFilesUrl.data && hearingNoticeFilesUrl.data.length > 0){
				property.hearingNoticeFiles = property.hearingNoticeFiles.concat(hearingNoticeFilesUrl.data)
			} else {
				property.hearingNoticeFiles = hearingNoticeFilesUrl.data;
			}
		}
		formData.delete('file');
		const response = await axios.post(`/updateProperty?env=${datastore.env}&preHoaId=${preHoaId}&preOrgId=${preOrgId}`,property);
		return response;
	}

	static async getAssignedMail(objectId: string, limit: number, page: number) {
		return await axios.get(`/getAssignedMail?env=${datastore.env}&objectId=${objectId}&limit=${limit}&page=${page}`);
	}

	static async getAssignedEmail(objectId: string, limit?: number, page?: number, emailId?: string) {
		return await axios.get(`/getAssignedEmail?env=${datastore.env}&objectId=${objectId}&limit=${limit}&page=${page}&emailId=${emailId ? emailId : ''}`);
	}

	static async unlinkPropertyFromHoa(property:any,hoaId:string) {
		return await axios.post(`/unlinkPropertyFromHoa?env=${datastore.env}&hoaId=${hoaId}`,property);
	}


	static async saveReportedViolation(violation:any, propertyId:string,update:boolean) {
		if(update){
			return await axios.post(`/updateReportedViolation?env=${datastore.env}&propertyId=${propertyId}`,violation);
		} else {
			return await axios.post(`/createReportedViolation?env=${datastore.env}&propertyId=${propertyId}`,violation);
		}

	}

	static async saveOrUpdateMultipleViolation(violationList:any, propertyId:string, organizationId: string) {
		const currnetDateObj = new Date();
		const currnetDate = `${currnetDateObj.getMonth()+1}-${currnetDateObj.getDate()}-${currnetDateObj.getFullYear()}`;

		for(const violation of violationList) {
			if ((Array.isArray(violation.newViolationFileToUpload) && violation.newViolationFileToUpload.length > 0) 
				&& (Array.isArray(violation.newRenamedViolationFileToUpload) && violation.newRenamedViolationFileToUpload.length > 0)) {
			
				const data = {
					propertyId,
					date: currnetDate,
					sourceIdType: violation.sourceIdType,
					newViolationFileToUpload: violation.newViolationFileToUpload,
					newRenamedViolationFileToUpload: violation.newRenamedViolationFileToUpload
				}
				
				const res = await axios.post('/copyMailAttachmentToViolation', data);
	
				if (res?.data) {
					violation.violationNoticeFiles = res.data;
				}
			}
		}

		return await axios.post(`/saveOrUpdateMultipleViolation?env=${datastore.env}&propertyId=${propertyId}&organizationId=${organizationId}`,violationList);
	}

	static async saveOrUpdateMultipleHoaDues(hoaDueList:any, propertyId:string) {
		const currnetDateObj = new Date();
		const currnetDate = `${currnetDateObj.getMonth()+1}-${currnetDateObj.getDate()}-${currnetDateObj.getFullYear()}`;

		for(const hoaDue of hoaDueList) {
			if ((Array.isArray(hoaDue.newHoaDueFileToUpload) && hoaDue.newHoaDueFileToUpload.length > 0) 
				&& (Array.isArray(hoaDue.newRenamedHoaDueFileToUpload) && hoaDue.newRenamedHoaDueFileToUpload.length > 0)) {
			
				const data = {
					propertyId,
					date: currnetDate,
					sourceIdType: hoaDue.sourceIdType,
					newHoaDueFileToUpload: hoaDue.newHoaDueFileToUpload,
					newRenamedHoaDueFileToUpload: hoaDue.newRenamedHoaDueFileToUpload
				}
				
				const res = await axios.post('/copyMailAttachmentToHoaDue', data);
	
				if (res?.data) {
					hoaDue.hoaDuesNoticeFiles = res.data;
				}
			}
		}
		return await axios.post(`/saveOrUpdateMultipleHoaDues?env=${datastore.env}&propertyId=${propertyId}`,hoaDueList);
	}

	static async getPropetyViolations(propertyId:string) {
		return await axios.get(`/getPropetyViolations?env=${datastore.env}&propertyId=${propertyId}`);
	}

	static async getHoaDues(propertyId:string) {
		return await axios.get(`/getHoaDues?env=${datastore.env}&propertyId=${propertyId}`);
	}

	static async removePropertyViolation(objectId:string) {
		return await axios.post(`/removePropertyViolation?env=${datastore.env}&objectId=${objectId}`);
	}

	static async removeMultiplePropertyViolation(violationIdsList:any) {
		const violationIds = violationIdsList.join();
		return await axios.post(`/removeMultiplePropertyViolation?env=${datastore.env}&violationIds=${violationIds}`);
	}

	static async removeMultipleHoaDues(hoaDueIdsList:any) {
		const hoaDuesIds = hoaDueIdsList.join();
		return await axios.post(`/removeMultipleHoaDues?env=${datastore.env}&hoaDuesIds=${hoaDuesIds}`);
	}

	static async removeProperty(objectId:string,hoaId:string, organizationId: string) {
		return await axios.post(`/removeProperty?env=${datastore.env}&id=${objectId}&hoaId=${hoaId}&organizationId=${organizationId}`);
	}

	static async getPropertiesOfHoa(hoaId:string, limit:number, pageNo:number, externalId?: string, selectedOrganization?: string) {
		return await axios.get(`/getPropertiesOfHoa?env=${datastore.env}&hoaId=${hoaId}&limit=${limit}&pageNo=${pageNo}&externalId=${externalId ? externalId : ''}&selectedOrganization=${selectedOrganization}`);
	}

	static async getHoasOfMunicipality(municipalityId:string) {
		return await axios.get(`/getHoasOfMunicipality?env=${datastore.env}&municipalityId=${municipalityId}`);
	}

	static async getMails(numberOfMails: number, pageNo: number, options:any) {
		return await axios.get(`/getMails?&env=${datastore.env}&pageNo=${pageNo}&numberOfMails=${numberOfMails}`,{
			params: {
			  options: options
			}
		});
	}

	// static async getMailsDownload(mail:any) {
	// 	const ceilingValue = Math.ceil(mail.count / 1000);
	// 	const options = mail.options || {};
	// 	let output: any = [];
	// 	const promises = Array.from({ length: ceilingValue }, (_, i) => {
	// 		const page = i + 1;
	// 		return dashboardServices.getMails(1000, page, options);
	// 	});
	// 	const results = await Promise.all(promises);
	// 	output = results.flatMap(({ data }) => data.mails || []);

	// 	createExcelForMailList(output);
	// }

	static async propertyAssignToMail(mail: any) {
		return await axios.post(`/propertyAssignToMail?env=${datastore.env}`,mail);
	}

	static async propertyUpdateAvailable(payload: any) {
		return await axios.post(`/propertyUpdateAvailable?env=${datastore.env}`,payload);
	}

	static async updatePropertyAvailableCheck(payload: any) {
		return await axios.post(`/updatePropertyAvailableCheck?env=${datastore.env}`,payload);
	}

	static async propertyAssignToEmail(email: any) {
		return await axios.post(`/propertyAssignToEmail?env=${datastore.env}`,email);
	}

	static async getRequests(numberOfRequests: number, pageNo: number, options:any, selectedOrganization?: any) {
		return await axios.get(`/getRequests?&env=${datastore.env}&pageNo=${pageNo}&numberOfRequests=${numberOfRequests}&selectedOrganization=${selectedOrganization}`,{
			params: {
			  options: options
			}
		});
	}

	static async getDocuments(numberOfDocuments: number, pageNo: number, options:any, selectedOrganization?: any) {
		return await axios.get(`/getDocuments?&env=${datastore.env}&pageNo=${pageNo}&numberOfDocuments=${numberOfDocuments}&selectedOrganization=${selectedOrganization}`,{
			params: {
			  options: options
			}
		});
	}

	static async createDocuments(files: any) {
		return await axios.post(`/createDocumentForHoa?env=${datastore.env}`, files);
	}

	static async createDocumentLog(message: any) {
		const log = await axios.post('/createDocumentLog?env=' + datastore.env, message);
		return log;
	}
  

	static async updateDocument(document:any) {
		return await axios.post(`/updateDocument?env=${datastore.env}`,document);
	}

	static async removeDocument(objectId: any){
		return await axios.post(`/removeDocument?env=${datastore.env}&objectId=${objectId}`)
	}

	static async getCreatedDocumentLogs(objectId:string) {
		return await axios.get(`/getCreatedDocumentLogs?env=${datastore.env}&id=${objectId}`);
	}

	static async updateRequestStatus(objectId: any, requestData: any){
		return await axios.post(`/updateRequestStatus?env=${datastore.env}&requestId=${objectId}`, requestData)
	}

	static async removeRequest(objectId: any){
		return await axios.post(`/removeRequest?env=${datastore.env}&objectId=${objectId}`)
	}

	static async updateMailStatus(mailData: any){
		return await axios.post(`/updateMailStatus?env=${datastore.env}`, mailData)
	}

	static async updateEmailStatus(emailData: any){
		return await axios.post(`/updateEmailStatus?env=${datastore.env}`, emailData)
	}

	static async getSelectedInvoicesCount(orgId: string, fromDate: any, toDate: any) {
		return await axios.get(`/getSelectedInvoicesCount?&env=${datastore.env}&orgId=${orgId}&fromDate=${fromDate}&toDate=${toDate}`);
	}

	static async getSelectedInvoices(orgId: string, fromDate: any, toDate: any, page: number, pageSize: number) {
		return await axios.get(`/getSelectedInvoices?&env=${datastore.env}&orgId=${orgId}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&pageSize=${pageSize}`);
	}

	static async getSelectedInvoicesCountV2(orgId: string, fromDate: any, toDate: any) {
		return await axios.get(`/getSelectedInvoicesCountV2?&env=${datastore.env}&orgId=${orgId}&fromDate=${fromDate}&toDate=${toDate}`);
	}

	static async getSelectedInvoicesV2(orgId: string, fromDate: any, toDate: any, page: number, pageSize: number, orgName: string, invoiceData:any) {
		return await axios.post(
			`/getSelectedInvoicesV2?&env=${datastore.env}&orgId=${orgId}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&pageSize=${pageSize}&orgName=${orgName}`,
			{
				invoiceData:invoiceData
			}
		);
	}

	static async getOrganizationListsByName(keyword: string) {
		return await axios.get(`/getOrganizationListsByName?&env=${datastore.env}&keyword=${keyword}`);
	}

	static async getHoaEnabledOrganization(keyword: string) {
		return await axios.get(`/getHoaEnabledOrganization?&env=${datastore.env}&keyword=${keyword}`);
	}

	static async getHoaDocumentType(keyword: string) {
		return await axios.get(`/getHoaDocumentType?&env=${datastore.env}&keyword=${keyword}`);
	}

	static async addWebhookUrl(data: any){
		return await axios.post(`/addWebhookUrl?env=${datastore.env}`, data)
	}

	static async updateWebhookUrl(data: any){
		return await axios.post(`/updateWebhookUrl?env=${datastore.env}`, data)
	}

	static async getWebhookUrls(numberOfNotifications: number, pageNo: number) {
		return await axios.get(`/getWebhookUrls?&env=${datastore.env}&numberOfNotifications=${numberOfNotifications}&pageNo=${pageNo}`);
	}

	static async getTriggerNotificationLogs(numberOfLogs: number, pageNo: number, options: any) {
		return await axios.get(`/getTriggerNotificationLogs?&env=${datastore.env}&numberOfLogs=${numberOfLogs}&pageNo=${pageNo}`, {
			params: {
				options: options
			}
		});
	}

	static async getEmails(numberOfEmails: number, pageNo: number, options:any) {
		return await axios.get(`/getEmails?&env=${datastore.env}&pageNo=${pageNo}&numberOfEmails=${numberOfEmails}`,{
			params: {
			  options: options
			}
		});
	}

	static async getMailById(id:string) {
		return await axios.get(`/getMailById?env=${datastore.env}&objectId=${id}`);
	}

	static async getEmailById(id:string) {
		return await axios.get(`/getEmailById?env=${datastore.env}&objectId=${id}`);
	}

	static async createMailLog(message: any) {
		const log = await axios.post('/createMailLog?env=' + datastore.env, message);
		return log;
	}

	static async getCreatedMailLogs(objectId:string, type: string) {
		return await axios.get(`/getCreatedMailLogs?env=${datastore.env}&id=${objectId}&type=${type}`);
	}

	static async getSpecificEmailsDataSortedByDate(fromDate:string, toDate: string) {
		return await axios.get(`/getSpecificEmailsDataSortedByDate?env=${datastore.env}&fromDate=${fromDate}&toDate=${toDate}`,{
			responseType: 'blob',
		  });
	}

   	static async getSpecificEmailsDataSortedByDateRange(fromDate:string, toDate: string) {
		return await axios.get(`/getSpecificEmailsDataSortedByDateRange?env=${datastore.env}&fromDate=${fromDate}&toDate=${toDate}`,{
			responseType: 'blob',
		  });
	}

	static async getHoaListCount(options:any,selectedOrganization?: any) {
	return await axios.get(`/getHoaListCount?&env=${datastore.env}&selectedOrganization=${selectedOrganization}`,{
		params: {
			  options: options
			},
		});
	}

	static async getFilteredHoaListXlSheet( numberOfHoas: number, pageNo: number, options:any, selectedOrganization?: any) {
	return await axios.get(`/getFilteredHoaListXlSheet?&env=${datastore.env}&pageNo=${pageNo}&numberOfHoas=${numberOfHoas}&selectedOrganization=${selectedOrganization}`,{
		params: {
			  options: options
			},
		});
	}

	static async getPropertyListCount(options:any,selectedOrganization?: any) {
	return await axios.get(`/getPropertyListCount?&env=${datastore.env}&selectedOrganization=${selectedOrganization}`,{
		params: {
			  options: options
			},
		});
	}

	static async getFilteredPropertyListXlSheet(numberOfProperty: number, pageNo: number, options:any, selectedOrganization?: any) {
	return await axios.get(`/getFilteredPropertyListXlSheet?&env=${datastore.env}&pageNo=${pageNo}&numberOfProperties=${numberOfProperty}&selectedOrganization=${selectedOrganization}`,{
			params: {
				options: options
			}
		});
	}
	static async verifySourceId(sourceId: string, type: string) {
		return await axios.get(`/verifySourceId?env=${datastore.env}&sourceId=${sourceId}&type=${type}`);
	}

	static async getDataFieldConfiguratorByOrganizationId(organizationId: string) {
		return await axios.get(`/getDataFieldConfiguratorByOrganizationId?&env=${datastore.env}&organizationId=${organizationId}`);
	}
	static async updateDataFieldConfigurator(dataFieldConfigurator:any) {
		return await axios.post(`/updateDataFieldConfigurator?env=${datastore.env}`,dataFieldConfigurator);
	}

	static async getFilesBySourceId(sourceId: string, sourceIdType: string, propertyId?: string) {
		return await axios.get(`/getFilesBySourceId?&env=${datastore.env}&sourceId=${sourceId}&sourceIdType=${sourceIdType}&propertyId=${propertyId}`);
	}

	static async getDocumentDetailsByDocumentId(sourceId: string) {
		return await axios.get(`/getDocumentDetailsByDocumentId?&env=${datastore.env}&sourceId=${sourceId}`);
	}

	static async updateMailToNonAssignable(mailId:string, documentType: string, currentUser: string, type?: string, noAssignableOrg?:string) {
		return await axios.post(`/updateMailToNonAssignable?env=${datastore.env}&mailId=${mailId}&documentType=${documentType}&type=${type}&noAssignableOrg=${noAssignableOrg}&currentUser=${currentUser}`)
	}

	static async updateMailToNonAssignableUnChecked(mailId:string,  documentType: string, currentUser?:string, type?: string, noAssignableOrg?:string) {
		return await axios.post(`/updateMailToNonAssignableUnChecked?env=${datastore.env}&mailId=${mailId}&documentType=${documentType}&type=${type}&noAssignableOrg=${noAssignableOrg}&currentUser=${currentUser}`)
	}
	static async updateCreatedLastHoaAppLog(id:string, type:string, amount:number) {
		return await axios.post(`/updateCreatedLastHoaAppLog?env=${datastore.env}`, {
			tagTypeId: id,
			type: type,
			amount: amount,
		});
	}

	static async mailFileNameDuplicationCheck(propertyId: string, mailFileName: string) {
		return await axios.get(`/mailFileNameDuplicationCheck?env=${datastore.env}&propertyId=${propertyId}&mailFileName=${mailFileName}`);
	}

	static async revertAddClientLog(data: any) {
		return await axios.post(`/revertAddClientLog?env=${datastore.env}`, data);
	}

	static async getPendingSource(numberOfRows: number, pageNo: number, options:any) {
		return await axios.get(`/getPendingSource?&env=${datastore.env}&pageNo=${pageNo}&numberOfRows=${numberOfRows}`,{
			params: {
			  options: options
			}
		});
	}
}